function readFailureMessage(reason: unknown): string {
  if (reason instanceof Error) {
    return reason.message;
  }
  if (typeof reason === 'string') {
    return reason;
  }
  if (typeof reason === 'object' && reason !== null && 'message' in reason) {
    const message = (reason as { message?: unknown }).message;
    if (typeof message === 'string') {
      return message;
    }
  }
  return '';
}

/** Detect stale-deploy / SPA-fallback chunk failures (HTML served as JS module). */
export function isAdminChunkLoadFailure(reason: unknown): boolean {
  const lower = readFailureMessage(reason).toLowerCase();
  if (lower.length === 0) {
    return false;
  }
  return (
    lower.includes('failed to fetch dynamically imported module') ||
    lower.includes('importing a module script failed') ||
    lower.includes('error loading dynamically imported module') ||
    lower.includes('failed to load module script') ||
    lower.includes('loading module') ||
    lower.includes('dynamically imported module') ||
    (lower.includes('mime type') && lower.includes('text/html'))
  );
}
